import { Component } from '@angular/core';
import { IFloatingFilterParams, TextFilterModel } from 'ag-grid-community';
import { AgFloatingFilterComponent } from 'ag-grid-angular';

@Component({
  standalone: false,
  selector: 'mm-text-floating-filter',
  templateUrl: './text-floating-filter.component.html',
  styleUrls: ['./text-floating-filter.component.scss'],
})
export class TextFloatingFilterComponent implements AgFloatingFilterComponent {
  params: IFloatingFilterParams;
  currentValue: null | string | undefined = 'Search';
  showClearText: Boolean = false;

  agInit(params: IFloatingFilterParams): void {
    this.params = params;
    this.setPlaceHolderText();
  }

  onParentModelChanged(parentModel: TextFilterModel) {
    // When the filter is empty we will receive a null value here
    if (!parentModel) {
      if(this.currentValue !== ''){
        this.showClearText = false; 
        this.currentValue = null;
        this.setPlaceHolderText();
      } 
    } else {
      this.currentValue = parentModel.filter;
    }
  }

  searchText() {
    this.showClearText = false;
    this.currentValue = '';
    this.setPlaceHolderText();
    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged(null, null);
    });
    return;
  }

  onClick() {
    if (this.currentValue === 'Search' || this.currentValue === 'Search symbol' || this.currentValue === 'Search name') {
      this.currentValue = ''
    }
  }

  onBlur() {
    if (!this.currentValue) {
      this.setPlaceHolderText();
    }
  }

  setPlaceHolderText() {
    if (this.params.column.getColId() === 'Symbol') {
      this.currentValue = 'Search symbol';
    } else if (this.params.column.getColId() === 'Name') {
      this.currentValue = 'Search name';
    } else {
      this.currentValue = 'Search';
    }
  }

  onInputBoxChanged() {
    if (!this.currentValue) {
      // clear the filter
      this.showClearText = false;
      this.params.parentFilterInstance((instance: any) => {
        instance.onFloatingFilterChanged(null, null);
      });
      return;
    }
    this.showClearText = true;
    const filterValue = this.currentValue;
    this.params.parentFilterInstance((instance: any) => {
      instance.onFloatingFilterChanged('contains', filterValue);
    });
  }
}